import { URL } from '../constants';
import { apiInstance } from '../instance';

export const getInternalTasksCount = () =>
  apiInstance.get(URL.INTERNAL_TASKS_PENDING_COUNT);
